import bugsnag from '../../bugsnag';
const ErrorBoundary = bugsnag.getPlugin('react');
export default ErrorBoundary;
